import { render, staticRenderFns } from "./ListHotel.vue?vue&type=template&id=83052620&"
import script from "./ListHotel.vue?vue&type=script&lang=js&"
export * from "./ListHotel.vue?vue&type=script&lang=js&"
import style0 from "./ListHotel.vue?vue&type=style&index=0&id=83052620&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports